var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53426 29.6313C5.6177 30.8166 6.54994 31.7649 7.734 31.8641C14.2519 32.4106 20.2121 32.4106 26.73 31.8641C27.9141 31.7649 28.8463 30.8166 28.9297 29.6313C29.4364 22.435 29.4364 15.6361 28.9297 8.4397C28.8463 7.25442 27.9143 6.3091 26.735 6.16421C23.689 5.79001 20.5064 5.30859 17.232 5.30859C13.9576 5.30859 10.775 5.79001 7.72904 6.16421C6.5497 6.30909 5.6177 7.25442 5.53426 8.4397C5.02764 15.6361 5.02764 22.435 5.53426 29.6313Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53426 29.6313C5.6177 30.8166 6.54994 31.7649 7.734 31.8641C14.2519 32.4106 20.2121 32.4106 26.73 31.8641C27.9141 31.7649 28.8463 30.8166 28.9297 29.6313C29.4364 22.435 29.4364 15.6361 28.9297 8.4397C28.8463 7.25442 27.9143 6.3091 26.735 6.16421C23.689 5.79001 20.5064 5.30859 17.232 5.30859C13.9576 5.30859 10.775 5.79001 7.72904 6.16421C6.5497 6.30909 5.6177 7.25442 5.53426 8.4397C5.02764 15.6361 5.02764 22.435 5.53426 29.6313Z",
    stroke: "#9B2C51",
    strokeWidth: 3.69255
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 16.0391H21.9243",
    stroke: "#9B2C51",
    strokeWidth: 3.69255,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 23.1953H18.2026",
    stroke: "#9B2C51",
    strokeWidth: 3.69255,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2715,
    y: 1.84766,
    width: 13.924,
    height: 7.30817,
    rx: 3.65408,
    fill: "#FFEAF1",
    stroke: "#9B2C51",
    strokeWidth: 3.69255,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.e5137aaa5e5dee5550f0bada002f255f.svg";
export { ForwardRef as ReactComponent };